/** User */
/** Info */
export const USER_INFO_REQUEST = 'USER_INFO_REQUEST';
export const USER_INFO_REQUEST_SUCCESS = 'USER_INFO_REQUEST_SUCCESS';
export const USER_INFO_REQUEST_FAILURE = 'USER_INFO_REQUEST_FAILURE';
